
<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: 'news'
};
</script>

<style>
</style>
